import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StudentService } from "../studentService";
import { Config } from "../../../personal-studio-components/service/Config.js";
import * as cls from "./singlePage.module.scss";
import imgPreview from "../../resources/icons/image-png.png";
import pdfPreview from "../../resources/icons/application-pdf-small.png";
import { Icon } from "../../../personal-studio-components/frame/Icon.jsx";
function SinglePage({
  el,
  idx,
  i,
  removeFile,
  page,
  scan_id,
  event_guid,
  handleFileUpdate,
  disabled,
}) {
  const { access_token } = useSelector((state) => state.token);
  const [src, setSrc] = useState("");
  const { contractId } = useSelector((state) => state.contract);
  const removePage = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const request = {
      method: "post",
      path: "/student/applications/academic/document/page/remove",
      data: {
        access_token,
        study_contract_id: contractId,
        event_guid,
        scan_id: scan_id,
        page_id: page.page_id,
      },
    };
    const res = await StudentService.send(request, (res) => {});
    if (!res.errors) {
      removeFile({ idx, i, scan_id });
    }
  };
  const handleOpenPage = () => {
    if (!src) return;
    const link = document.createElement("a");
    link.href = src;
    link.target = "_blank";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    async function getConfig() {
      await Config.load();
      const student_service = Config.get("student_service");
      const url =
        student_service +
        "/student/applications/academic/document/page/get?" +
        "study_contract_id=" +
        contractId +
        "&page_id=" +
        page.page_id;
      setSrc(url);
    }
    getConfig();
  }, []);
  return (
    <>
      <img
        onClick={handleOpenPage}
        src={
          page.mime_type_id === 7 || page.mime_type_id === 8
            ? imgPreview
            : page.mime_type_id === 6
              ? pdfPreview
              : ""
        }
        alt="загрузка..."
      />
      <button
        disabled={disabled}
        className={cls.removeFileButton}
        onClick={removePage}
      >
        ✖
      </button>
      <input
        disabled={disabled}
        className={cls.inputHidden}
        id={`input__file-${page.page_id}`}
        type="file"
        multiple
        onChange={(e) => handleFileUpdate(e, el, idx, page.page_id, i)}
        accept="jpg"
      />
      <label
        disabled={disabled}
        className={cls.changeFileButton}
        htmlFor={`input__file-${page.page_id}`}
      >
        <Icon name="double_arrows" className="icon" />
      </label>
    </>
  );
}

export default SinglePage;
